import { render } from "./Reviewing.vue?vue&type=template&id=292784bb&scoped=true"
import script from "./Reviewing.vue?vue&type=script&lang=js"
export * from "./Reviewing.vue?vue&type=script&lang=js"

import "./Reviewing.vue?vue&type=style&index=0&id=292784bb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-292784bb"]])

export default __exports__